'use strict';

$('#datepicker-from, #datepicker-to').datepicker({
    format: 'mm/dd/yyyy',
});

$('#datepicker-from, #datepicker-to').datepicker().on('changeDate', function (e) {
    $(this).datepicker('hide');
});

const $seeCourses = $('a#seeCourses');
const $inputs = $('#topic, #datepicker-from, #datepicker-to, #pd-hours');
const baseCgid = $('.mainbanner-figure').attr('data-cgid');
let searchUrl = new URL($seeCourses.attr('href'));
searchUrl.searchParams.set('cgid', baseCgid);
searchUrl.searchParams.set('view','list');
$seeCourses.attr('href', searchUrl);

$inputs.siblings().children('button').on('click', function () {
    const isHourList = $(this).parent().siblings('button').attr('id') === 'pd-hours';
    const $input = $(this).parent().siblings('button');
    const liData = JSON.parse($(this).attr('value'));

    if (isHourList) {
        $input.attr('data-hmin', liData.hmin);
        $input.attr('data-hmax', liData.hmax);
    } else {
        $input.attr('data-cgid', liData.id);
    }

    $input.trigger('change');
    $input.children('div').removeClass('text-muted').addClass('text-dark').html(liData.name);
});

$inputs.off('change').on('change', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const topicId = $('#topic').attr('data-cgid');
    const hourMin = $('#pd-hours').attr('data-hmin');
    const hourMax = $('#pd-hours').attr('data-hmax');
    const dateValueFrom = $('#datepicker-from').val() ? $('#datepicker-from').val().replace(/-/g, '/') : '';
    const dateValueTo = $('#datepicker-to').val() ? $('#datepicker-to').val().replace(/-/g, '/') : '';
    const dateFrom = Math.floor(new Date(dateValueFrom).getTime() / 1000);
    const dateTo = Math.floor(new Date(dateValueTo).getTime() / 1000);

    const searchUrl = new URL($seeCourses.attr('href'));
    searchUrl.searchParams.set('cgid', topicId || baseCgid)

    if ((dateTo || dateFrom) && (hourMin || hourMax)) {
        searchUrl.searchParams.set('prefn1', 'date');
        searchUrl.searchParams.set('prefmin1', isNaN(dateFrom) ? 0 : dateFrom);
        searchUrl.searchParams.set('prefmax1', isNaN(dateTo) ? 2147483647 : dateTo);

        searchUrl.searchParams.set('prefn2', 'pdHours');
        searchUrl.searchParams.set('prefmin2', hourMin);
        searchUrl.searchParams.set('prefmax2', hourMax);
    } else {

        if (dateTo || dateFrom) {
            searchUrl.searchParams.set('prefn1', 'date');
            searchUrl.searchParams.set('prefmin1', isNaN(dateFrom) ? 0 : dateFrom);
            searchUrl.searchParams.set('prefmax1', isNaN(dateTo) ? 2147483647 : dateTo);
        }

        if (hourMin && hourMax) {
            searchUrl.searchParams.set('prefn1', 'pdHours');
            searchUrl.searchParams.set('prefmin1', hourMin);
            searchUrl.searchParams.set('prefmax1', hourMax);
        }
    }

    $seeCourses.attr('href', searchUrl);
});